import { useI18n } from '../contexts/I18nContext';

export const useTranslation = () => {
  const i18nContext = useI18n();
  
  // Version optimisée de la fonction de traduction qui gère l'état de chargement
  const t = (key: string, params?: Record<string, any>): string => {
    // Si en chargement, renvoyer un placeholder ou une chaîne vide
    if (i18nContext.isLoading) {
      return ''; // Chaîne vide pendant le chargement pour éviter d'afficher les clés
    }
    
    // Sinon, utiliser la fonction de traduction normale
    return i18nContext.t(key, params);
  };
  
  return {
    t,
    lang: i18nContext.lang,
    setLang: i18nContext.setLang,
    getPathForLang: i18nContext.getPathForLang,
    isLoading: i18nContext.isLoading
  };
}; 